import CancelIcon from '@mui/icons-material/Cancel';
import { Row } from 'blocks/CommonLayout';
import { Text } from 'blocks/Text';
import { useEffect, useState } from 'react';
import { ModalProps } from './modal.interface';
import * as S from './modal.styles';

const Modal = ({ children, className, open, onClose, width = '566px', title }: ModalProps) => {
  const [openModal, setOpenModal] = useState(open);

  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  return (
    <S.Wrraper>
      <S.ModalContainer $active={openModal}>
        {onClose ? (
          <S.ModalContainerBg $active={openModal} onClick={() => onClose()}></S.ModalContainerBg>
        ) : (
          <S.ModalContainerBg $active={openModal}></S.ModalContainerBg>
        )}
        <S.ModalContainerContent $width={width} $active={openModal}>
          {onClose && (
            <S.ModalContainerHead as={Row} justify="flex-end">
              <CancelIcon onClick={() => onClose()} />
            </S.ModalContainerHead>
          )}
          {title && (
            <S.ModalContainerHeadTitle as={Text} letterSpace={false} bold>
              {title}
            </S.ModalContainerHeadTitle>
          )}
          <div className="content">{children}</div>
        </S.ModalContainerContent>
      </S.ModalContainer>
    </S.Wrraper>
  );
};

export default Modal;
